import React, { useState, useEffect, useRef } from "react";
import btnArrow from "../assets/img/section-btn-arrow.webp";
import add from "../assets/img/add.png";
import deleteIcon from "../assets/img/delete.webp";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import useCartStore from "../api/cart";
import { cartSubtotal, withoutService } from "../utils/cartSummary";

const pathURL = process.env.REACT_APP_API_URL;

const fetchCode = async ({ queryKey }) => {
  const id = queryKey[1];
  // `studio=1` asks for the counter-only services too (the chainstitch
  // lines). fxryshop's copy of this screen deliberately does not.
  // See fxrybackend/controllers/service.js.
  const { data } = await axios.get(
    `${pathURL}service/getservicebyitem/${id}?studio=1`,
  );
  return data;
};

const ItemDetail = () => {
  const { cartItems, updateCartItem, removeFromCart } = useCartStore();
  const [total, setTotal] = useState("00.00");
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const location = useLocation();
  const selectedType = location.state?.selectedType || "";

  const navigate = useNavigate();

  const handleApply = () => {
    navigate("/checkout");
  };

  const addNew = () => {
    sessionStorage.setItem("addnewitem", true);
    navigate("/types", {
      state: { addNewItem: true },
    });
  };

  const addService = (data) => {
    console.log(data, "aman");
    sessionStorage.setItem("addnewservice", true);
    sessionStorage.setItem("SelectedPlan", data?.pricing_plan);
    sessionStorage.setItem("selectedItem", data?.name);
    sessionStorage.setItem("selectedItems", JSON.stringify(data));
    navigate("/alteration", {
      state: { addNewService: true, selectedItem: data, addNewItem: false },
    });
  };

  const [subtotalAmount, setsubtotalAmount] = useState(0);
  useEffect(() => {
    // Reached with an empty basket (e.g. opened directly): start over instead
    // of crashing on the missing cart.
    if (!cartItems?.[0]?.itemsData || !cartItems?.[0]?.services) {
      navigate("/", { replace: true });
      return;
    }
    // A service saved after pressing Back into the service screen can lack
    // item_details (the selected item was already cleared), so match safely;
    // such a service is dropped rather than crashing the basket.
    const sameItem = (item, service) =>
      item?.id === service?.item_details?.id &&
      item?.name?.trim() === service?.item_details?.name?.trim();
    const filteredData = {
      itemsData: cartItems[0].itemsData.filter((item) =>
        cartItems[0].services.some((service) => sameItem(item, service)),
      ),
      services: cartItems[0].services.filter((service) =>
        cartItems[0].itemsData.some((item) => sameItem(item, service)),
      ),
    };
    updateCartItem(cartItems[0]?.id, {
      itemsData: filteredData.itemsData,
      services: filteredData.services,
    });
    cartItems[0]?.services?.reduce((acc, item) => {
      const pricingPlan = cartItems[0]?.itemsData?.filter(
        (items) => items?.id == item?.item_details?.id,
      );
      let updatedPrice;
      if (pricingPlan != undefined) {
        updatedPrice =
          pricingPlan[0]?.pricing_plan === "Standard"
            ? item?.standard_price
            : item?.premium_price;
        const mainprice = acc + parseFloat(updatedPrice);
        setsubtotalAmount(mainprice);
        return acc + parseFloat(updatedPrice);
      }
      // itemsData not loaded yet, so `?.filter` gave undefined and there is
      // no plan to price this line with. Carry the running total forward.
      // Falling out of the callback returned undefined instead, and the next
      // round added a number to it, so the subtotal showed NaN.
      return acc;
    }, 0);
    sessionStorage.removeItem("SelectedPlan");
    sessionStorage.removeItem("selectedItem");
    sessionStorage.removeItem("selectedItems");
    sessionStorage.removeItem("addnewitem");
    sessionStorage.removeItem("addnewservice");
    sessionStorage.removeItem("addedBatch");
    sessionStorage.removeItem("task");
    sessionStorage.removeItem("option");
    sessionStorage.removeItem("optionprice");
    if (cartItems && cartItems?.length == 0) {
      sessionStorage.removeItem("product-store");
    }
    if (
      cartItems[0]?.itemsData?.length == 0 &&
      cartItems[0]?.services?.length == 0
    ) {
      sessionStorage.removeItem("product-store");
    }
  }, []);

  // Take one service off from this screen, the same act as the × on the
  // checkout summary. Removing a garment's last service removes the garment
  // too, so nothing is left with no work on it. Unlike checkout, an empty
  // basket is a fine place to stand here: the page keeps its "Add a new
  // items" button, which is the way back.
  const removeService = (serviceIndex) => {
    const cart = cartItems?.[0];
    if (!cart?.id) return;
    const next = withoutService(cart, serviceIndex);
    updateCartItem(cart.id, next);
    setsubtotalAmount(cartSubtotal(next));
  };

  const handleRemove = (serviceArr, itemIndex) => {
    const filteredItems = cartItems[0]?.itemsData?.filter(
      (item, i) => i != itemIndex,
    );
    const filteredServices = cartItems[0]?.services?.filter(
      (service, i) => !serviceArr.includes(i),
    );

    updateCartItem(cartItems[0].id, {
      itemsData: filteredItems,
      services: filteredServices,
    });
    if (filteredServices && filteredServices.length == 0) {
      updateCartItem(cartItems[0]?.id, {
        services: [],
        itemsData: [],
      });
      setsubtotalAmount(0);
      navigate("/item-detail");
    }
    filteredServices.reduce((acc, item) => {
      const pricingPlan = cartItems[0]?.itemsData?.filter(
        (items) => items?.id == item?.item_details?.id,
      );
      let updatedPrice;
      if (pricingPlan != undefined) {
        updatedPrice =
          pricingPlan[0]?.pricing_plan === "Standard"
            ? item.standard_price
            : item.premium_price;
        const mainprice = acc + parseFloat(updatedPrice);
        setsubtotalAmount(mainprice);
        return acc + parseFloat(updatedPrice);
      }
      // itemsData not loaded yet, so `?.filter` gave undefined and there is
      // no plan to price this line with. Carry the running total forward.
      // Falling out of the callback returned undefined instead, and the next
      // round added a number to it, so the subtotal showed NaN.
      return acc;
    }, 0);
  };

  function toCamelCase(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return (
    <section className="item-detail-section items-section same-bg-section relative">
      <div className="container padding-x-all ">
        <div className="item-detail-box sec-com-padding flex-box justify-between align-center">
          <div
            className="show-detail-box scroll-wrapper"
            style={{ maxHeight: "33rem", overflowY: "scroll" }}
          >
            <button className="add-new-item-box relative" onClick={addNew}>
              <h4 className="add-new-text">Add a new items</h4>
            </button>
            {cartItems[0]?.itemsData?.map((item, index) => {
              return (
                <>
                  <div
                    className="price-detail-box"
                    style={{ marginTop: "1rem" }}
                  >
                    <div className="item-name-price flex-box justify-between relative">
                      <h3
                        className="name-price-text item-name-text"
                        key={index}
                      >
                        {item?.name.trim() || "-"}{" "}
                        <span>
                          <img
                            src={deleteIcon}
                            onClick={() => {
                              let indexData = cartItems[0]?.services
                                ?.map((service, index) =>
                                  service?.item_details?.id == item?.id
                                    ? index
                                    : undefined,
                                )
                                .filter((service) => service != undefined);
                              handleRemove(indexData, index);
                            }}
                            alt=""
                          />
                        </span>{" "}
                      </h3>
                      <h3 className="name-price-text">
                        {item?.itemsData?.type} {item?.pricing_plan}
                      </h3>
                      <p className="para">Order Details</p>
                      {cartItems[0]?.services?.map((service, serviceIndex) => {
                        if (service?.item_details?.id == item?.id) {
                          return (
                            <React.Fragment
                              key={`service-${service._id || serviceIndex}`}
                            >
                              <table className="item-table">
                                <tbody>
                                  <tr>
                                    <td>
                                      <p>Item Description:</p>
                                    </td>
                                    <td>
                                      <p>
                                        {item?.describe || item?.description}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <p>Service Type:</p>
                                    </td>
                                    <td>
                                      <p>{service?.selectedService}</p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <p>Service:</p>
                                    </td>
                                    <td>
                                      <div className="item-table__service">
                                        <p>{service.name.trim()}</p>
                                        <button
                                          type="button"
                                          className="checkout-line__remove"
                                          aria-label={`Remove ${service.name.trim()}`}
                                          title="Remove"
                                          onClick={() =>
                                            removeService(serviceIndex)
                                          }
                                        >
                                          ×
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <p>Price:</p>
                                    </td>
                                    <td>
                                      <p>
                                        {item?.pricing_plan === "Standard"
                                          ? "$ " + service?.standard_price
                                          : "$ " + service?.premium_price}
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </React.Fragment>
                          );
                        }
                        return null;
                      })}
                    </div>
                    <div className="add-another-service-box">
                      <button onClick={() => addService(item)}>
                        <h5>
                          {" "}
                          <span>
                            <img src={add} alt="" />
                          </span>{" "}
                          Add another service to your {item?.name.trim()}
                        </h5>
                      </button>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className="sub-total-box">
            <ul className="sub-total scroll-wrapper">
              {cartItems[0]?.services?.map((carts, index) => {
                let pricingPlan = cartItems[0]?.itemsData?.find((itm) => {
                  return carts?.item_details?.id == itm?.id;
                });
                return (
                  <li key={carts._id || `cart-${index}`}>
                    <h4>{toCamelCase(carts?.name)}</h4>
                    <div className="checkout-line__right">
                      <h4>
                        $
                        {pricingPlan?.pricing_plan === "Standard"
                          ? carts.standard_price
                          : carts.premium_price}
                      </h4>
                      <button
                        type="button"
                        className="checkout-line__remove"
                        aria-label={`Remove ${toCamelCase(carts?.name)}`}
                        title="Remove"
                        onClick={() => removeService(index)}
                      >
                        ×
                      </button>
                    </div>
                  </li>
                );
              })}
              {/* <li>
                <h4>Pickup & Drop-off fee</h4>
                <h4>$5.00</h4>
              </li> */}
              <li>
                <h4>Tax - </h4>
                <h4>Calculated at next step</h4>
              </li>
              <li>
                <h4>Your basket</h4>
                <h4>${subtotalAmount}</h4>
              </li>
            </ul>
            <button
              className="checkout-btn section-main-btn"
              onClick={handleApply}
              disabled={cartItems[0]?.itemsData?.length == 0 ? true : false}
            >
              Continue to checkout
              <span>
                <img src={btnArrow} alt="" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItemDetail;
